<template>
  <App>
    <div class="card card-flush">
      <div class="card-body">
        <div class="d-flex justify-content-between mb-5">
          <h2 class="fw-bolder">Banca Avaliadora - {{$page.props.globalVar.anoMostra}}</h2>
          <span>O número ao lado ao nome do avaliador é a quantidade de projetos que o mesmo está avaliando.</span>
          <button class="btn btn-sm btn-info" @click="distribuirProjetos" :disabled="loading"> <i class="fa fa-spin fa-spinner" v-if="loading"></i> Distribuir Projetos</button>
        </div>

        <div class="d-flex mb-5">
          <h6>Total de Avaliadores - {{avaliadores.length}}</h6>
          <span class="mx-3">|</span>
          <h6>Avaliadores Selecionados - {{form.avaliadores.length}}</h6>
        </div>

        <form @submit.prevent="submit">
          <div class="row">
            <div class="col-3 mb-3" v-for="(usuario, index) in avaliadores">
              <div class="form-check form-check-custom form-check-solid">
                <input class="form-check-input"
                       type="checkbox"
                       :name="usuario.name"
                       :value="usuario.id"
                       :id="usuario.name"
                       v-model="form.avaliadores"/>
                <label class="form-check-label" :for="usuario.name">
                  {{ usuario.name }} ({{usuario.projetos}})
                </label>
              </div>
            </div>
          </div>
        </form>
      </div>

      <div class="card-footer">
        <button class="btn btn-primary" @click="submit">Salvar</button>
      </div>
    </div>
  </App>
</template>
<script>
import App from "@layout/App";
import {Link, useForm} from "@inertiajs/inertia-vue3";
import SubmitButton from "@forms/SubmitButton";
import Datepicker from "@forms/Datepicker";
import FormGroup from "@forms/FormGroup";
import axios from "axios";
import { error } from "@settings/toastr";
import {success} from "../../Settings/toastr";

export default {
  inheritAttrs: false,
  props: ['banca', 'avaliadores'],

  components: {
    FormGroup,
    Datepicker,
    SubmitButton,
    App,
    Link,
  },

  data: _ => ({
    loading: false
  }),

  setup(props) {
    const form = useForm({avaliadores: props.banca.avaliadores});

    return {form};
  },

  mounted() {
    this.init();
  },

  methods: {
    init() {
      this.emitter.emit('title', 'Banca Avaliadora');
      this.emitter.emit('breadcrumb', [
        {title: 'Dashboard', link: 'app.home'},
        {title: 'Atualizar Banca Avaliadora'},
      ]);

      this.emitter.emit('action', {
            show: false,
          }
      );
    },

    submit() {
      this.form.post(this.route('app.avaliadores.banca.update'), {
        onError: error
      });
    },

    distribuirProjetos() {
      this.loading = true
      axios.post(this.route('app.projetos.atribui-avaliadores')).then(_ => {
        this.loading = false
        success('Distribuição de projetos para os avaliadores realizado com sucesso.')
      })
    }
  },
};
</script>
